export default __webpack_public_path__ + "static/media/icons.7c429810.svg";